module.exports = __webpack_public_path__ + "static/icons/siniestros-banner.375f36c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/siniestros-banner.png
// module id = z9KH
// module chunks = 1